import CountryPageRenderer from '../components/CountryPageRenderer';
import indonesiaData from '../data/country-pages/indonesia';

export default function IndonesiaCountryPage() {
  return <CountryPageRenderer data={indonesiaData} />;
}
